import React from 'react';
import { useDispatch, useSelector } from '../../../lib/react-redux-hooks';
import QuickStartGuide from './QuickStartGuide';
import YourTeam from './YourTeam';
import GetPreapproved from './GetPreapproved';
import YourTeamModal from './YourTeam/YourTeamModal';
import PreapprovedTrueModal from './GetPreapproved/modals/PreapprovedTrueModal';
import PreapprovedFalseModal from './GetPreapproved/modals/PreapprovedFalseModal';
import ContactModal from './GetPreapproved/modals/ContactModal';
import FileUploadModal from './GetPreapproved/modals/FileUploadModal';
import DocumentsReceivedModal from './GetPreapproved/modals/DocumentsReceivedModal';
import YourNextTask from './YourNextTask';
import ProductTourModal from './ProductTourModal';
import styles from '../../../styles/sass/components/Dashboard.module.scss';
import VerificationComponent from './Verification';
import VerificationModal from './Verification/Modals';
import RecommendedListings from './RecommendedListings';
import PhoneNumberOAuthModal from './Verification/Modals/PhoneNumberOAuthModal';
import { fetchSignupSurvey } from '../../../actions/signupSurvey';

const style = {
  modalStyle: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
};

interface Props {
  router: any;
}
const Dashboard = ({ router }: Props) => {
  const dispatch = useDispatch();
  const {
    user,
    quickStartCompleted,
    showQuickStartGuide,
    showYourNextTask,
    preapproved,
    selectedAgent,
    token,
    firstName,
    showPhoneNumberOauthModal,
    phoneNumber,
    onboarding,
  } = useSelector((state: any) => {
    return {
      user: state.auth.user,
      quickStartCompleted: state.dashboard.quickStartCompleted,
      showQuickStartGuide: state.dashboard.showQuickStartGuide,
      showYourNextTask: state.dashboard.showYourNextTask,
      preapproved: state.signupSurvey.signupSurveyDetails.preapproved,
      selectedAgent: state.dashboard.selectedAgent,
      token: state.auth.token,
      firstName: state.auth.user.firstName,
      showPhoneNumberOauthModal: state.dashboard.showPhoneNumberOauthModal,
      phoneNumber: state.auth.user.phoneNumber,
      onboarding: state.auth.user.onboarding || {},
    };
  });

  React.useEffect(() => {
    if (token) {
      dispatch(fetchSignupSurvey(token));
    }
  }, [token]);
  return (
    <React.Fragment>
      <div className={styles.dashboardContainer}>
        <div className={styles.heading}>Hey {firstName}, welcome home 👋 </div>
        <VerificationComponent dispatch={dispatch} user={user} token={token} />

        <div className={styles.componentContainer}>
          <div className={styles.leftComponents}>
            {showQuickStartGuide && <QuickStartGuide router={router} />}
            {/* Your next task component will only be rendered if quick start guide is completed */}
            {(onboarding.quickStartComplete || quickStartCompleted) &&
              showYourNextTask && <YourNextTask router={router} />}
          </div>
          <div className={styles.rightComponents}>
            <YourTeam />
            {preapproved !== 'Buying in cash' && <GetPreapproved />}
          </div>
        </div>
        <div className={styles.componentContainer}>
          <RecommendedListings />
        </div>
      </div>
      {/* Dashboard Modals */}
      <VerificationModal modalStyle={style.modalStyle} />
      <ContactModal modalStyle={style.modalStyle} />
      <PreapprovedTrueModal modalStyle={style.modalStyle} />
      <PreapprovedFalseModal modalStyle={style.modalStyle} />
      <YourTeamModal agent={selectedAgent} />
      <FileUploadModal modalStyle={style.modalStyle} token={token} />
      <DocumentsReceivedModal modalStyle={style.modalStyle} />
      <ProductTourModal />
      <PhoneNumberOAuthModal
        phoneNumber={phoneNumber}
        dispatch={dispatch}
        showPhoneNumberOauthModal={showPhoneNumberOauthModal}
        modalStyle={style.modalStyle}
        token={token}
      />
    </React.Fragment>
  );
};

export default Dashboard;
